// Modules
import { MbscModule } from '@mobiscroll/angular';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { SwiperModule } from 'swiper/angular';
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { ServiceWorkerModule } from '@angular/service-worker';

import { AppRouterModule } from './app-router/app-router.module';
import { SharedModule } from './shared/shared.module';
import { CashierModule } from './cashier/cashier.module';
import { MyAccountModule } from './app-myaccount/myaccount.module';

// Components
import { AppComponent } from './app.component';
import { AppHeaderComponent } from './app-header/app-header.component';
import { AppFooterComponent } from './app-footer/app-footer.component';
import { HomeComponent } from './app-home/home.component';
import { BannerComponent } from './app-banner/app-banner.component';
import { FooterstickynavComponent } from './footerstickynav/footerstickynav.component';
import { FooterSvgComponent } from './footer-svg/footer-svg.component';
import { AppServererrorMsgComponent } from './app-servererror-msg/app-servererror-msg.component';
import { FooterCreateaccountBlockComponent } from './footer-createaccount-block/footer-createaccount-block.component';
import { FormValidationComponent } from './form-validation/form-validation.component';
import { AppCustomErrorMsgComponent } from './app-custom-error-msg/app-custom-error-msg.component';
import { NotificationComponent } from './notification/notification.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { GuestHomeComponent } from './app-home/guest-home/guest-home.component';
import { LoggedinHomeComponent } from './app-home/loggedin-home/loggedin-home.component';
import { HomepagePromotionsComponent } from './app-home/homepage-promotions/homepage-promotions.component';
import { TimerBannerComponent } from './timer-banner/timer-banner.component';
import { DashboardBonusComponent } from './app-home/loggedin-home/dashboard-bonus/dashboard-bonus.component';
import { AppPaceLoaderComponent } from './app-pace-loader/app-pace-loader.component';
import { AppTopGamesComponent } from './app-top-games/app-top-games.component';
import { HostedCashierComponent } from './hosted-cashier/hosted-cashier.component';
import { AppJackpotComponent } from './app-jackpot/app-jackpot.component';
import { AppPendingWithdrawalModalComponent } from './app-pending-withdrawal-modal/app-pending-withdrawal-modal.component';
import { AppLeftnavSignupComponent } from './app-registration/app-leftnav-signup/app-leftnav-signup.component';
import { AppLeftnavRegistrationComponent } from './app-leftnav-registration/app-leftnav-registration.component';
import { AppCashierComponent } from './app-cashier/app-cashier.component';
import { AppRegGobackComponent } from './app-registration/app-reg-goback/app-reg-goback.component';
import { GamingwindowComponent } from './gaming/gamingwindow/gamingwindow.component';
import { GamesContentComponent } from './gaming/games-content/games-content.component';
import { AppDepositPopupComponent } from './app-deposit-popup/app-deposit-popup.component';
import { AppZimplerCompleteProfileComponent } from './app-zimpler-complete-profile/app-zimpler-complete-profile.component';
import { AppNavPanelComponent } from './app-nav-panel/app-nav-panel.component';
import { GameSubheaderBannerComponent } from './lobby/game-subheader-banner/game-subheader-banner.component';
import { DummyRegisterPageComponent } from './dummy-register-page/dummy-register-page.component';
import { TimerComponent } from './timer/timer.component';
import { CreateAccountPnpComponent } from './create-account-pnp/create-account-pnp.component';
import { JuridictionModalComponent } from './juridiction-modal/juridiction-modal.component';

// Services
import { WINDOW_PROVIDERS } from './services/window.service';
import { AjaxService } from './services/ajax.service';
import { EmitterService } from './services/emitter.service';
import { Utilities } from './services/utilities.services';
import { SocketService } from './services/socket.service';
import { CountryDataService } from './services/country.service';
import { AuthGuard } from './services/auth-gaurd.service';
import { RouterGuardService } from './services/router-guard.service';
import { ProfileSettingService } from './services/profile-setting.service';
import { BannerService } from './services/banner.service';
import { RealityCheckService } from './services/reality-check.service';
import { LogoutEmitServiceService } from './services/logout-emit-service.service';
import { UserDetailsService } from './services/user-details.service';
import { AppDetailsService } from './services/app-details.services';
import { LiveGamesService } from './services/live-games.service';
import { PaymentService } from './services/payment.service';
import { GameWindowService } from './services/gameWindow.services';
import { PromotionsService } from './services/promotions.service';
import { HttpResponseHandlerService } from './services/http-response-handler.service';
import { BonusService } from './app-myaccount/bonuses/services/bonus.service';
import { AjaxObservableService } from './services/ajax-observable.service';
import { SessionLimitService } from './services/session-limit.service';
import { PnpZimplerService } from './services/pnp-zimpler.service';
import { PaymentAjaxService } from './payment-system/services/payment-ajax.service';
import { HostedCashierPaymentsService } from './services/hosted-cashier-payments.service';
import { DisableDesktopRouteGuardService } from './services/disable-desktop-route-guard.service';

// Directives
import { AutofocusDirectiveDirective } from './autofocus-directive.directive';

// Pipes
import { DatePipe } from '@angular/common';

// Utility
import { GamingUtility } from './gaming/gaming.utility';
import { environment } from '../environments/environment';
import { AppCustomPreloader } from './custom-preloader';
import { EnvironmentService } from './shared/services/environment.services';
import { WidgetComponent } from './widget/widget.component';

@NgModule({
  declarations: [
    AppComponent,
    AppHeaderComponent,
    AppFooterComponent,
    HomeComponent,
    BannerComponent,
    FooterstickynavComponent,
    FooterSvgComponent,
    AppServererrorMsgComponent,
    FooterCreateaccountBlockComponent,
    FormValidationComponent,
    AppCustomErrorMsgComponent,
    NotificationComponent,
    MaintenanceComponent,
    AutofocusDirectiveDirective,
    TimerBannerComponent,
    AutofocusDirectiveDirective,
    GuestHomeComponent,
    LoggedinHomeComponent,
    GameSubheaderBannerComponent,
    HomepagePromotionsComponent,
    DashboardBonusComponent,
    AppPaceLoaderComponent,
    AppTopGamesComponent,
    HostedCashierComponent,
    AppJackpotComponent,
    AppPendingWithdrawalModalComponent,
    AppLeftnavSignupComponent,
    AppLeftnavRegistrationComponent,
    AppCashierComponent,
    AppRegGobackComponent,
    GamingwindowComponent,
    GamesContentComponent,
    AppDepositPopupComponent,
    AppZimplerCompleteProfileComponent,
    AppNavPanelComponent,
    CreateAccountPnpComponent,
    
    JuridictionModalComponent,
    DummyRegisterPageComponent,
    TimerComponent,
  ],
  imports: [
    FormsModule,
    MbscModule, 
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRouterModule,
    InfiniteScrollModule,
    SwiperModule,
    CashierModule,
    SharedModule,
    MyAccountModule,
    WidgetComponent,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
  ],
  providers: [
    AjaxService,
    EmitterService,
    UserDetailsService,
    AppDetailsService,
    CountryDataService,
    Utilities,
    PaymentService,
    RealityCheckService,
    LogoutEmitServiceService,
    DatePipe,
    GameWindowService,
    ProfileSettingService,
    BannerService,
    PromotionsService,
    SocketService,
    WINDOW_PROVIDERS,
    AuthGuard,
    LiveGamesService,
    RouterGuardService,
    GamingUtility,
    HttpResponseHandlerService,
    BonusService,
    AjaxObservableService,
    SessionLimitService,
    HostedCashierPaymentsService,
    AppCustomPreloader,
    PnpZimplerService,
    PaymentAjaxService,
    DisableDesktopRouteGuardService,
    EnvironmentService,
    {
      provide:APP_INITIALIZER,
      useFactory:initializeActiveLanguages,
      deps: [EnvironmentService],
      multi: true,
    }
  ],
  exports:[
    AppJackpotComponent,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
export function HttpLoaderFactory(httpClient: HttpClient) {
  let langUrl;
  //if(!environment.production){
    langUrl = environment.apiUrl+environment.langpath;
  // } else {
  //   langUrl = environment.langpath;
  // }
  return new TranslateHttpLoader(httpClient, langUrl, '.json');
}

export function initializeActiveLanguages(environmentServie:EnvironmentService):()=>Promise<any>{
  return () => environmentServie.loadActiveLanguagesConfig();
}
